import { logError } from './sentryUtils';

let authModulePromise;

export const getAuth = async () => {
    if (!authModulePromise) {
        authModulePromise = import('aws-amplify');
    }
    const { Auth } = await authModulePromise;
    return Auth;
};

/**
 * Decodes the custom state parameter returned by AWS Cognito/Amplify.
 *
 * Amplify encodes the `customState` passed to `federatedSignIn` by appending it
 * to a random nonce, separated by a hyphen, and HEX encoding the custom state value.
 *
 * Format: `[nonce]-[HexEncodedCustomState]`
 *
 * @param {string} state - The `state` query parameter from the URL.
 * @returns {string|null} The decoded custom state (URL) if valid, or null if parsing fails.
 */
export const decodeAmplifyState = (state) => {
    if (!state) return null;
    try {
        // Amplify format: [randomString]-[customState]
        // customState matches what we sent (window.location.origin)
        const parts = state.split('-');
        if (parts.length > 1) {
            const encodedOrigin = parts[parts.length - 1];
            // Try to hex decode
            const decoded = encodedOrigin
                .match(/.{1,2}/g)
                .map((byte) => String.fromCharCode(parseInt(byte, 16)))
                .join('');
            if (decoded.startsWith('http')) {
                return decoded;
            }
        }
    } catch (e) {
        logError(e);
    }
    return null;
};
